import { render, staticRenderFns } from "./EditProgramParameters.vue?vue&type=template&id=19e05fe8"
import script from "./EditProgramParameters.vue?vue&type=script&lang=js"
export * from "./EditProgramParameters.vue?vue&type=script&lang=js"
import style0 from "./EditProgramParameters.vue?vue&type=style&index=0&id=19e05fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports